import axios from "axios";

export default {
  hamtaPartial: function (apiUrl, data) {
    const config = {
      headers: { "Content-Type": "application/json" },
    };

    return axios.post(
      apiUrl,
      data,
      config
    );
  },
};
